const LoaderScreen = () => (
  <div className="async-loader">
    <div className="background">
      <div className="animation">
        <div className="loader" />
      </div>
    </div>
  </div>
);

export default LoaderScreen;
